import { KeyRound } from "lucide-react";

export const CodeReveal = ({ code }) => (
  <div className="bg-[#c1ff72]/10 border border-[#c1ff72]/40 rounded-lg p-4 text-center" data-testid="card-code-reveal">
    <p className="text-sm flex items-center justify-center gap-2"><KeyRound className="w-4 h-4 text-[#c1ff72]" /> Kartencode (wird nur jetzt angezeigt)</p>
    <p className="font-mono text-2xl tracking-widest text-[#c1ff72] my-2 select-all" data-testid="card-code-value">{code}</p>
    <p className="text-xs text-[#71717A]">Gespeichert wird nur ein Hash. Bei Verlust kann ein neuer Code ausgestellt werden (der alte wird ungültig).</p>
  </div>
);
